<template>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="85%" :before-close="closeDialog">
        <div class="handle-box-search a">
            <div class="handle-box">
                <div class="head-search">
                    <el-row class="head-search">
                        <el-col :span="12" style="margin-top: 10px">
                            <span class="title">签约/续费时间:</span>
                            <el-date-picker
                                v-model="fixed_array"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="timeChange"
                                style="width: 340px"
                            >
                            </el-date-picker>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">司机姓名:</span>
                            <!-- 搜索司机姓名 -->
                            <el-input
                                v-model="search_data.real_name"
                                placeholder="请输入司机姓名"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverSigningCountLists"
                            ></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="head-search a">
                        <el-col :span="12">
                            <span class="title">全职/兼职:</span>

                            <el-select
                                v-model="search_data.job_type"
                                placeholder="请选择工作类型"
                                clearable
                                @keyup.enter.native="searchDriverSigningCountLists"
                            >
                                <el-option label="全职" value="1"> </el-option>
                                <el-option label="兼职" value="2"> </el-option>
                                <el-option label="按单" value="3"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">司机手机号:</span>
                            <!-- 搜索司机手机号 -->
                            <el-input
                                v-model="search_data.phone"
                                placeholder="请输入司机手机号"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverSigningCountLists"
                            ></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">签约类型:</span>

                            <el-select
                                v-model="search_data.type"
                                placeholder="请选择签约类型"
                                clearable
                                @keyup.enter.native="searchDriverSigningCountLists"
                            >
                                <el-option label="签约：缴纳当月费用" value="1"> </el-option>
                                <el-option label="续费：缴纳下月费用" value="2"> </el-option>
                                <el-option label="管理员扣除天数" value="3"> </el-option>
                                <el-option label="管理员调整日期" value="4"> </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchDriverSigningCountLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="resetting">刷新</el-button>
            <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
            <el-button icon="el-icon-setting" @click="toExport" v-else>导出</el-button>
            <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...
            </div>
        </div>

        <div style="margin: 20px; display: flex; justify-content: left; color: #606266">
            <div style="margin-right: 20px">签约金额：{{ all.amount }}</div>
            <div style="margin-right: 20px">全职司机金额：{{ driver_count.full_time.full_time_amount }}</div>
            <div style="margin-right: 20px">兼职司机金额：{{ driver_count.part_time.part_time_amount }}</div>
            <div style="margin-right: 20px">按单司机金额：{{ driver_count.by_order_time.by_order_time_amount }}</div>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->

            <el-table-column label="司机姓名" prop="real_name" min-width="90"> </el-table-column>
            <el-table-column label="手机号" prop="phone" min-width="100"></el-table-column>
            <el-table-column label="全职/兼职" prop="job_type"> </el-table-column>

            <el-table-column label="签约/续费日期" prop="time.YmdHis" min-width="100"></el-table-column>
            <el-table-column label="调整前职业类型" prop="admin_adjust_signing_type" min-width="100"></el-table-column>
            <el-table-column label="签约费用（元）" prop="real_amount" min-width="100"></el-table-column>

            <el-table-column prop="type" label="签约/续费"> </el-table-column>

            <el-table-column label="签约/续费到期日" prop="signing_end_time.YmdHis" min-width="130"> </el-table-column>
            <el-table-column label="操作人" prop="admin_name" min-width="130"> </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </el-dialog>
</template>

<script>
let _this;
export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.getToday();
            _this.search_data.fixed_array = JSON.stringify(['between', ..._this.fixed_array]);
            _this.searchDriverSigningCountLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            fixed_array: [],

            all: {
                amount: '',
                count: ''
            },
            driver_count: {
                part_time: {
                    part_time_amount: '',
                    
                    part_time_count: ''
                },
                full_time: {
                    full_time_amount: '',
                    full_time_count: ''
                },
                by_order_time: {
                    signing_time_amount: '',
                    signing_time_count: ''
                }
            },

            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0,
            loading: false,

            result_data: [],

            show: false,

            //签约统计查询数据
            search_data: {
                page: 1,
                limit: 10,
                real_name: '',
                fixed_array: '',
                job_type: '',
                type: '',
                phone: ''
            },

            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },

            tableData: []
        };
    },
    methods: {
        // 获取年月日 日期时间控件显示默认值
        getToday() {
            console.log('获取年月日方法');

            var date = new Date(); //获取时间
            var year = date.getFullYear(); //获取年
            var month = date.getMonth(); //获取月
            var day = date.getDate(); //获取日
            month = month > 9 ? month : '0' + month;
            day = day > 9 ? day : '0' + day;
            var arr1 = [new Date(year, month, day, 0, 0, 0), new Date(year, month, day, 23, 59, 59)];
            console.log(arr1, 'arr1');
            _this.fixed_array = arr1;
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.resetting();
        },
        resetting() {
            console.log('重置方法');
            _this.search_data = {
                page: 1,
                limit: 10,
                real_name: '',
                fixed_array: '',
                job_type: '',
                type: '',
                phone: ''
            };
            _this.fixed_array = '';
            _this.searchDriverSigningCountLists();
        },
        toExport() {
            _this.loading = true;
            _this.getExcelData();
        },
        getExcelData() {
            _this
                .$post('/statistics/driverSigningCountLists', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;
                    _this.loading = false;
                    // console.log('getExcelData');

                    if (this.$route.path == '/driverSigningRules') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            _this.excelData.push({
                                real_name: res.data.result[i].real_name,
                                phone: res.data.result[i].phone,
                                job_type: res.data.result[i].job_type,
                                time: res.data.result[i].time.YmdHis,
                                real_amount: res.data.result[i].real_amount,
                                type: res.data.result[i].type,
                                signing_end_time: res.data.result[i].signing_end_time.YmdHis
                            });
                        }

                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.search_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor(((res.data.page * res.data.limit) / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },
        timeChange(val) {
            // console.log(val);

            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between', ..._this.fixed_array]);
            } else {
                _this.search_data.fixed_array = '';
            }
        },
        searchDriverSigningCountLists() {
            _this.search_data.page = 1;

            _this.driverSigningCountLists();
        },
        driverSigningCountLists() {
            _this
                .$post('/statistics/driverSigningCountLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    if (res.data.result.length == 0) {
                        this.$message.error('暂无数据');
                    }
                    console.log('driverSigningCountLists');
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.result;
                    _this.result_data = res.data;
                    _this.all.amount = res.data.driver_count.all.amount;
                    _this.all.count = res.data.driver_count.all.count;
                    _this.driver_count.part_time.part_time_count = res.data.driver_count.part_time.part_time_count;
                    _this.driver_count.part_time.part_time_amount = res.data.driver_count.part_time.part_time_amount;
                    _this.driver_count.by_order_time.by_order_time_amount = res.data.driver_count.by_order_time.by_order_time_amount;
                    _this.driver_count.full_time.full_time_count = res.data.driver_count.full_time.full_time_count;
                    _this.driver_count.full_time.full_time_amount = res.data.driver_count.full_time.full_time_amount;
                    console.log(_this.tableData, '_this.tableData');
                })
                .catch((err) => {});
        },
        //签约统计翻页组件的回调
        pages_function(search_data) {
            console.log(search_data, '父组件接收到的值');
            //赋值
            _this.search_data = search_data;

            //初始化列表
            _this.driverSigningCountLists();
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['司机姓名', '手机号', '全职/兼职', '签约/续费日期', '签约费用（元）', '签约/续费', '签约/续费到期日'];
            const filterVal = ['real_name', 'phone', 'job_type', 'time', 'real_amount', 'type', 'signing_end_time'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        }
    }
};
</script>

<style scoped>
.head-search .title {
    width: 200px !important;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-input {
    max-width: 340px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}
</style>
<style>
.a .el-input--small .el-input__inner {
    width: 340px !important;
}
</style>
